import React from 'react';
import { withPageBase } from '../../components/PageBase';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Timeline from './Timeline';
import Alert from '../../components/Alert';
import ToastHOC from '../../components/ToastHOC';
import { showPlaceHolderOnTimeline } from './data/selector';

let { id: module_id } = module;

const TimelinePage = () => {
  class TimelinePageWrapper extends React.Component {
    render() {
      let { toasts } = this.props;

      let toastElements = [];

      if (toasts) {
        toastElements = toasts.map((item) => <Alert {...item.spec} />);
      }

      return (
        <div>
          {toastElements}
          <Timeline />
        </div>
      );
    }
  }

  return withPageBase(TimelinePageWrapper, {
    title: `${module_id}.title`,
    showPlaceHolder: showPlaceHolderOnTimeline,
  });
};

const toastOptions = {
  module_id: module_id,
  dismissOnUnmount: ['APPOINTMENT_RESCHEDULE_FAILED_TOAST'],
};

export default withRouter(
  connect(() => {})(ToastHOC(toastOptions, TimelinePage()))
);
